export default {"src":"/_next/static/media/prophetic.38f0d0ca.svg","height":25,"width":20,"blurWidth":0,"blurHeight":0};